/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const FeetWalk = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M48.84 111.357c9.408-2.584 6.457-14.248 3.19-23.058-.072-.256-.151-.493-.508-.35-3.927 2.767-11.84 5.355-17.568 4.565 1.136 11.661 4.97 21.572 14.886 18.843z" />
    <path d="M50.983 86.503c-4.537 2.712-10.77 4.562-16.698 4.402-2.473-9.495-7.378-17.314-7.526-25.487-.064-3.646-.053-7.223.688-11.582.932-5.481 2.685-13.881 8.49-15.668C43.96 35.704 48 44.937 50.154 50.53c1.125 2.914 2.158 6.078 2.339 8.379.86 10.79-5.99 16.443-1.51 27.595z" />
    <g>
      <path d="M79.768 88.09c-9.48-2.272-6.893-14.027-3.898-22.941.063-.258.136-.497.498-.365 4.011 2.633 12 4.959 17.699 3.981-.776 11.692-4.302 21.724-14.299 19.326z" />
      <path d="M76.89 63.319c4.619 2.561 10.906 4.205 16.825 3.85 2.18-9.572 6.84-17.548 6.735-25.724-.048-3.646-.168-7.221-1.042-11.552-1.101-5.448-3.115-13.787-8.97-15.38-8.095-2.198-11.848 7.16-13.83 12.823-1.034 2.949-1.967 6.149-2.078 8.454-.53 10.812 6.493 16.234 2.36 27.529z" />
    </g>
  </svg>
);

export default extendIcon(FeetWalk);
